import { Button, IconButton } from '@material-ui/core'
import { Close as CloseIcon } from '@material-ui/icons'
import { SnackbarAction, SnackbarKey } from 'notistack'
import React, { FC, MouseEvent, useCallback } from 'react'
import styled from 'styled-components'

interface CommissionsToastActionsProps {
  snackbarKey: SnackbarKey
  dismissToast: () => void
  navigateToDispensaryDashboard: () => void
}

const CloseButton = styled(IconButton)`
  margin-left: 10px;

  &.MuiIconButton-root:hover {
    background-color: #ffffff4c;
  }
`

const CommissionsToastActions: FC<CommissionsToastActionsProps> = ({
  dismissToast,
  navigateToDispensaryDashboard,
}) => {
  /*
   * Prevents further event propagation in case the toast's onClick() parameter is used.
   * This is done to avoid calling the function passed into onClick().
   */
  const onClickNavigate = useCallback(
    (event: MouseEvent<HTMLElement>) => {
      event.stopPropagation()
      navigateToDispensaryDashboard()
    },
    [navigateToDispensaryDashboard],
  )
  const onClickClose = useCallback(
    (event: MouseEvent<HTMLElement>) => {
      event.stopPropagation()
      dismissToast()
    },
    [dismissToast],
  )

  return (
    <>
      <Button color="inherit" onClick={onClickNavigate}>
        Complete Setup
      </Button>
      <CloseButton size="small" aria-label="close" color="inherit" onClick={onClickClose}>
        <CloseIcon fontSize="small" />
      </CloseButton>
    </>
  )
}

export const getCommissionsToastActions = (
  props: Omit<CommissionsToastActionsProps, 'snackbarKey'>,
): SnackbarAction => {
  const Actions = (snackbarKey: SnackbarKey) => {
    return <CommissionsToastActions snackbarKey={snackbarKey} {...props} />
  }
  return Actions
}
